<template>
<div class="chapter">
<div class="inner_page">
<a id="page_v"></a>
<h2 class="tochd"><span class="bold">Contents</span></h2>
<h2 class="toc1"><a href="#/xhtml/06_Intro">Introduction</a></h2>
<h2 class="toc1"><a href="#/xhtml/07_FM1">Family tree: House of Lancaster</a></h2>
<h2 class="toc1"><a href="#/xhtml/08_FM2">Family tree: House of York</a></h2>
<h2 class="toc1"><a href="#/xhtml/09_FM3">Family tree: Katherine of Aragon’s descent from Edward III</a></h2>
<h2 class="toc2a"><a href="#/xhtml/10_chap01"><span class="tpad">Chapter 1</span> Out of Avalon</a></h2>
<h2 class="toc2"><a href="#/xhtml/11_chap02"><span class="tpad">Chapter 2</span> The Once and Future King</a></h2>
<h2 class="toc2"><span href="#/xhtml/12_chap03" title="Link target outside of Sample"><span class="tpad">Chapter 3</span> A Christian Prince</span></h2>
<h2 class="toc2"><span href="#/xhtml/13_chap04" title="Link target outside of Sample"><span class="tpad">Chapter 4</span> Diseased Minds</span></h2>
<h2 class="toc2"><span href="#/xhtml/14_chap05" title="Link target outside of Sample"><span class="tpad">Chapter 5</span> The King’s Most Dear Son</span></h2>
<h2 class="toc2"><span href="#/xhtml/15_chap06" title="Link target outside of Sample"><span class="tpad">Chapter 6</span> The Prince of Wales</span></h2>
<h2 class="toc2"><span href="#/xhtml/16_chap07" title="Link target outside of Sample"><span class="tpad">Chapter 7</span> The Maintenance of His State</span></h2>
<h2 class="toc2"><span href="#/xhtml/17_chap08" title="Link target outside of Sample"><span class="tpad">Chapter 8</span> The Marcher Lord</span></h2>
<h2 class="toc2"><span href="#/xhtml/18_chap09" title="Link target outside of Sample"><span class="tpad">Chapter 9</span> So Great the Abundance</span></h2>
<h2 class="toc2"><span href="#/xhtml/19_chap10" title="Link target outside of Sample"><span class="tpad">Chapter 10</span> A Rose Between Thorns</span></h2>
<h2 class="toc2"><span href="#/xhtml/20_chap11" title="Link target outside of Sample"><span class="tpad">Chapter 11</span> The Spanish Princess</span></h2>
<h2 class="toc2"><span href="#/xhtml/21_chap12" title="Link target outside of Sample"><span class="tpad">Chapter 12</span> Secure in His Kingdom</span></h2>
<h2 class="toc2"><span href="#/xhtml/22_chap13" title="Link target outside of Sample"><span class="tpad">Chapter 13</span> The Condition of Wedlock</span></h2>
<h2 class="toc2"><span href="#/xhtml/23_chap14" title="Link target outside of Sample"><span class="tpad">Chapter 14</span> Portrait of a Prince</span></h2>
<h2 class="toc2"><span href="#/xhtml/24_chap15" title="Link target outside of Sample"><span class="tpad">Chapter 15</span> A Night in Spain</span></h2>
<h2 class="toc2"><span href="#/xhtml/25_chap16" title="Link target outside of Sample"><span class="tpad">Chapter 16</span> Righteous Order and Wisdom</span></h2>
<h2 class="toc2"><span href="#/xhtml/26_chap17" title="Link target outside of Sample"><span class="tpad">Chapter 17</span> Le Morte d’Arthur</span></h2>
<h2 class="toc2"><span href="#/xhtml/27_chap18" title="Link target outside of Sample"><span class="tpad">Chapter 18</span> King Arthur</span></h2>
<h2 class="toc1a"><span href="#/xhtml/28_epi" title="Link target outside of Sample">Epilogue: The Shadow of a Prince</span></h2>
<h2 class="toc1"><span href="#/xhtml/29_notes" title="Link target outside of Sample">Notes</span></h2>
<h2 class="toc1"><span href="#/xhtml/30_bib" title="Link target outside of Sample">Selected Bibliography</span></h2>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 05_Toc.vue?847bc790